import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'

type Props = {
  limitEqualToCurrent: boolean,
  isOpen: boolean,
  onContinueInviting: () => void,
  onClose: () => void,
}

const InviteUserWarningModal = ({ limitEqualToCurrent, isOpen, onContinueInviting, onClose } : Props) => {
  const title = limitEqualToCurrent ? "You're about to exceed your seat limit" : "You've exceeded your seat limit"
  const verb = limitEqualToCurrent ? 'will go' : 'went'
  return (
    <Modal isOpen={isOpen} size='medium'>
      <ModalHeader title={title} onClose={onClose} />
      <ModalBody>
          🎊 Great that more of your colleagues want to join inSided! By inviting a new user, {verb} over your current seat limit. That’s no problem - you can still continue. We'll reach out to discuss adjusting your limit, and won’t charge you anything without your consent.
      </ModalBody>
      <ModalFooter>
        <ButtonControl title='Continue inviting' variant='primary' onClick={onContinueInviting} class='qa-continue-invite-user' />
        <ButtonControl title='Cancel' onClick={() => onClose()} />
      </ModalFooter>
    </Modal>
  )
}

export default InviteUserWarningModal
